<template>
  <div>
    <SjRange :range="range" v-model="value" :labels="labels" />
  </div>
</template>

<script>
export default {
  data() {
    return {
      range: [0, 100],
      value: [10, 90],
      labels: Array(100)
        .fill(0)
        .map((v, i) => i)
    };
  }
};
</script>

<style scoped lang="less"></style>
